import {
  Button,
  getMainImageSrcForObj, TableBodyLine, Text1
} from '@touche-lts/panel-ui/dist'
import cl from 'classnames'
import { PictureNameLine } from 'components'
import { useState } from 'react'
import { storesTableWidths } from '../assigned-stores-table.utils'
import styles from './assigned-stores-table-body-line.module.scss'
import { AssignedStoresTableBodyLineProps } from './assigned-stores-table-body-line.types'
import { useGetScrollWidth } from 'hooks/custom-hooks'

const AssignedStoresTableBodyLineComponent = (
  props: AssignedStoresTableBodyLineProps
) => {
  const { className, style, store, userRoleLabel, onUnassignClick } = props
  const [mouseOver, setMouseOver] = useState<boolean>(false)

  return (
    <TableBodyLine
      className={className}
      style={style}
      onMouseEnter={() => setMouseOver(true)}
      onMouseLeave={() => setMouseOver(false)}
      cells={[
        { widthPx: storesTableWidths.id, children: store.id },
        {
          widthPx: storesTableWidths.store,
          children: (
            <PictureNameLine
              imageSrc={getMainImageSrcForObj(store)}
              imageBoxShadow
              name={store.name}
            />
          )
        },
        {
          // widthPercentage: 100,
          widthPx: storesTableWidths.role,
          children: (
            <>
              <Text1 overflowEllipsis>{userRoleLabel}</Text1>
              <Button
                preset='link'
                className={cl(styles.removeButton, {
                  [styles.fullOpacity]: mouseOver
                })}
                onClick={onUnassignClick}
                title='Unassign store from user'
              >
                Unassign
              </Button>
            </>
          )
        }
      ]}
    />
  )
}

const AssignedStoresTableBodyLine = AssignedStoresTableBodyLineComponent
export { AssignedStoresTableBodyLine }
